export default "__VITE_ASSET__uUvUJPWo__"